import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useRef } from "react";
import { GroupedData } from "./useDashboardTableData";
import { useDashboardTableStore } from "./useDashboardTableStore";

export const usePrintViewSync = (
    groupedData: GroupedData[],
    gridReferences: React.MutableRefObject<Record<string, AgGridReact>>,
    tableColumnDefs: ColDef[],
) => {
    const isColumnDefsCustomized = useDashboardTableStore((state) => state.isColumnDefsCustomized);
    const hasData = groupedData?.some((group) => group.items?.length > 0 || group.rowData?.length > 0) ?? false;

    const previousGroupedDataRef = useRef<GroupedData[]>([]);

    const isSame = useMemo(() => {
        const previous = previousGroupedDataRef.current;
        return (
            previous.length === groupedData.length &&
            previous.every((group, index) => {
                const currentGroup = groupedData[index];
                return (
                    group.groupLabel === currentGroup.groupLabel &&
                    group.items?.length === currentGroup.items?.length &&
                    group.rowData === currentGroup.rowData
                );
            })
        );
    }, [groupedData]);

    const shouldUpdatePrintView = useMemo(() => hasData && !isSame, [hasData, isSame]);

    useEffect(() => {
        if (shouldUpdatePrintView) {
            const firstGrid = Object.values(gridReferences.current)[0];
            const printColumnDefs = firstGrid?.api?.getColumnDefs();
            previousGroupedDataRef.current = groupedData;
            useDashboardTableStore.getState().actions.setPrintData({
                groupedData,
                columnDefs: isColumnDefsCustomized ? printColumnDefs ?? [] : tableColumnDefs,
            });
        }
    }, [shouldUpdatePrintView, groupedData, isColumnDefsCustomized, gridReferences, tableColumnDefs]);
};
